export const PropertyImagesType = {
  location: 1,
  Image: 2
};
